<template>
  <div>
    <div class="d-flex justify-content-between align-self-center my-4">
      <span class="title">商戶列表</span>
      <!-- <span class="must-fill-label">*必須填寫</span> -->
    </div>
    <AGCEditGroupInput v-if="role === 'admin'"
                       v-model="inputVal.isShown"
                       :fieldName="'isShown'"
                       :options="showMerchant"
                       :inputType="'dropdown'"
                       label="是否顯示"
                       name="是否顯示"
                       disabled
                       :enableEdit="role === 'admin'"
                       @is-save="setIsShown"
    >
    </AGCEditGroupInput>
    <AGCEditGroupInput v-if="role === 'admin' && cachedInputVal.isShown"
                       v-model="inputVal.order"
                       :fieldName="'order'"
                       :inputType="'input'"
                       label="次序"
                       type="number"
                       name="次序"
                       disabled
                       :enableEdit="role === 'admin'"

    >
    </AGCEditGroupInput>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import AGCEditGroupInput from '../form/AGCEditGroupInput.vue';

import formMixin from '../../mixins/form';
import vModelMixin from '../../mixins/v-model';

export default {
  props: {
    tagOptions: Array,
  },
  mixins: [formMixin, vModelMixin],
  components: {
    AGCEditGroupInput,
  },
  data: () => ({
    showMerchant: [
      { text: '顯示', value: 1 },
      { text: '不顯示', value: 0 },
    ],
    cachedInputVal: [],
  }),
  computed: {
    ...mapGetters(['role']),
  },
  mounted() {
    this.cachedInputVal = { ...this.inputVal };
  },
  methods: {
    setIsShown() {
      this.cachedInputVal.isShown = this.inputVal.isShown;
    },

  },
};
</script>

<style lang="scss" scoped>
h4 {
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  margin: 0;
  color: #3A4047;
}

.must-fill-label {
  float: right;
  font-size: 14px;
  color: #f54b4e;
  font-weight: 400;
}

</style>
